


























































































































import { VNode, CreateElement } from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { SwStatusFlag } from '../sw-status-flag';
import { SwToggle } from '../sw-toggle';
import { SwTransitionExpand } from '../sw-transition';
import SwPanelGroup from './sw-panel-group.vue';
import {
  ProvidedPanelParam,
  PanelSummaryConfig,
  PanelBulletConfig,
} from './types';
import { VueRenderFunction } from '../common-types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-panel';

/**
 * @event request-toggle-change `(toggled: boolean)`
 */
@Component({
  components:{
    SwIcon,
    SwToggle,
    SwStatusFlag,
    SwTransitionExpand,
  },
})
export default class SwPanel extends SwExtendedVue{
  // props
  @Prop({ type: String, required: true })
  panelId: string;

  @Prop({ type: [String, Function], default: '' })
  title: string | VueRenderFunction;

  @Prop({ type: Object, default: null })
  summaryConfig: PanelSummaryConfig | null;

  @Prop({ type: Array, default: null })
  panelBullets: PanelBulletConfig[] | null;

  @Inject()
  panelParam: ProvidedPanelParam;

  // data
  cssPrefix = cssPrefix;

  // computed
  get isExpanded(): boolean {
    return this.panelParam.expandedPanels.findIndex(e => (e === this.panelId)) >= 0;
  }

  get theme(): string {
    return this.panelParam.theme;
  }

  get toggleName(): string {
    return `__panel-toggle-${Math.floor(Math.random() * 100000000)}`;
  }

  // methods
  @Inject()
  readonly claimPanelExpanded: SwPanelGroup['claimPanelExpanded'];

  private onHeaderClick(event: MouseEvent) {
    event.stopPropagation();
    this.claimPanelExpanded(this.panelId, !this.isExpanded);
  }

  private handleToggleChange(value: boolean, ev:Event) {
    ev.stopPropagation();
    this.$emit('request-toggle-change', value);
  }

  private render(h: CreateElement): VNode {// tslint:disable-line
    const rootNode: VNode = (
      <div class={[`${cssPrefix}`, `${cssPrefix}--${this.theme}`, 'sw-flexbox', 'sw-flexbox--column']}>
        <div
          class={[`${cssPrefix}__header`,
            'sw-flexbox__flex-none',
            'sw-flexbox', 'sw-flexbox--center-items',
            { [`${cssPrefix}__header--expanded`]: this.isExpanded },
          ]}
          on-click={this.onHeaderClick}
        >
          <span class={[`${cssPrefix}__header__arrow`, { [`${cssPrefix}__header__arrow--expanded`]: this.isExpanded }, 'sw-flexbox__flex-none']}>
            <span class={[`${cssPrefix}__header__arrow__cont`, 'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify']}>
              <sw-icon name="arrow-left" as-block />
            </span>
          </span>
          <div class={[`${cssPrefix}__header__title`, 'sw-flexbox__flex']}>{
            typeof this.title === 'string' ? this.title : this.title(h)
          }</div>
          {
            !!this.summaryConfig ? (
              <div
                class={[`${cssPrefix}__header__summary`,
                  'sw-flexbox__flex-none',
                  'sw-flexbox', 'sw-flexbox--center-items',
                ]}
              >
              { !!this.summaryConfig.text ? (<span class={[`${cssPrefix}__header__summary__text`]}>{ this.summaryConfig.text }</span>) : null }
              {
                this.summaryConfig.controlMode === 'status' ? (
                  <span class={[`${cssPrefix}__header__summary__status`]}>
                    <sw-status-flag props-name={this.summaryConfig.controlValue} as-block />
                  </span>
                ) : (this.summaryConfig.controlMode === 'toggle' ? (
                  <sw-toggle
                    class={[`${cssPrefix}__header__summary__toggle`]}
                    props-name={this.toggleName} value={!!this.summaryConfig.controlValue}
                    on-change={this.handleToggleChange}
                  ></sw-toggle>
                ) : null)
              }
              </div>
            ) : null
          }
        </div>
        <sw-transition-expand direction="vertical">
          <div class={[`${cssPrefix}__main`]} v-show={this.isExpanded}>
          {
            this.panelBullets !== null ? (
              <div class={`${cssPrefix}__main__bullet__container`}>
              {
                this.panelBullets.map<VNode>((panelBullet, index) => {
                  return (
                    <div
                      key={index}
                      class={[`${cssPrefix}__main__bullet`, 'sw-flexbox']}
                    >
                      <span class={[`${cssPrefix}__main__bullet__title`, 'sw-flexbox', 'sw-flexbox--center-items']}>{panelBullet.title}</span>
                      <span class={['sw-flexbox', 'sw-flexbox__flex']}></span>
                      <span class={[`${cssPrefix}__main__bullet__text`, 'sw-flexbox', 'sw-flexbox--center-items']}>
                        {panelBullet.text}
                        <sw-status-flag
                          class={[`${cssPrefix}__main__bullet__text__status`, 'sw-flexbox', 'sw-flexbox--center-items']}
                          name={panelBullet.controlValue}
                        />
                      </span>
                    </div> as VNode
                  );
                })
              }
              </div>
            ) : null
          }
          {
            !!this.$scopedSlots.default ? (
              <div class={[`${cssPrefix}__main__inner`]}>
                { utilService.getVueScopedSlot(this.$scopedSlots) }
              </div>
            ) : null
          }
          </div>
        </sw-transition-expand>
      </div> as VNode
    );

    return rootNode;
  }
}
